// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.task-accordion_lang-pair {\n  font-weight: normal !important;\n  font-size: 16px !important;\n}\n.translation-text-title {\n  color: #5a5964;\n  font-weight: 400;\n  font-size: 10px;\n}\n.translation-text-bold {\n  color: #000;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: normal;\n}\n.translation-text-primary {\n  color: #000;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
